module.exports = __webpack_public_path__ + "media/images/l_key-49a80c45fde21ef89dadf8cd213a2ced.jpeg";